module.exports = __webpack_public_path__ + "img/bet-confirm.58b9c470.svg";